(function() {
    angular
        .module("app")
        .factory("authenticationService", authenticationService)

    authenticationService.$inject = [
        "$http",
        "$state",
        "$rootScope",
        "$cookies",
        "usersService",
        "authorizationService"
    ]

    function authenticationService(
        $http,
        $state,
        $rootScope,
        $cookies,
        usersService,
        authorizationService
    ) {
        var service = {}

        /**
            @param {string} username
            @param {string} password
            @param successCallback
            @param failureCallback
         **/
        service.login = function(username, password, successCallback, failureCallback) {

            $rootScope.is_authenticated = false

            $http({
                method: "POST",
                url: $rootScope.config.apiUrl + "/sessions",
                data: {
                    user: {
                        username: username,
                        password: password
                    }
                },
                headers: {"Accept": "application/json"}
            }).then(success, failure)

            function success(response) {
                gtag("set", {
                    user: {
                        customer_id: response.data.customer_id,
                        customer_name: response.data.customer_name,
                        email: response.data.email,
                        user_id: response.data.id,
                    },
                })
                gtag("event", "login")

                service.setUser(response.data)
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        /**
            @param user
         **/
        service.setUser = function(user) {
            $rootScope.user = Object.prototype.toString.call(user) === "[object Object]" ? user : {}
            if ($rootScope.user.hasOwnProperty("username")) {
                $rootScope.is_authenticated = true
                $rootScope.user.lastRetrieved = Math.floor(Date.now() / 1000)
                if ($rootScope.user.scoped_permissions && $rootScope.user.scoped_permissions.scopes) {
                    authorizationService.initialize(
                        $rootScope.user.scoped_permissions.scopes,
                        $rootScope.user.scoped_permissions.schema_version
                    )
                }
                service.setAuthCookie(user)
            } else {
                $rootScope.is_authenticated = false
            }
        }

        /**
            @param user
         **/
        service.setAuthCookie = function(user) {

            const options = {
                path: "/",
                domain: $rootScope.config.cookieDomain,
                expires: new Date("1 day ago")
            }

            $cookies.putObject("user", user, options)

            if ($rootScope.config.label === "FM Docker") {
                options.domain = "localhost"
                $cookies.putObject("user", user, options)
            }
        }

        var refreshInFlight = false

        service.refreshScopedPermissionsIfNeeded = function(newHash) {
            if (refreshInFlight) {
                return
            }
            refreshInFlight = true

            return usersService.getSessionRefresh()
                .then(function(session) {
                    // Logout sets $rootScope.user = {} (truthy empty), so check is_authenticated too.
                    if (!$rootScope.user || !$rootScope.is_authenticated) return
                    $rootScope.user.scoped_permissions = session.scoped_permissions
                    $rootScope.user.permissions_state_hash = session.permissions_state_hash

                    if (session.scoped_permissions && session.scoped_permissions.scopes) {
                        authorizationService.initialize(
                            session.scoped_permissions.scopes,
                            session.scoped_permissions.schema_version
                        )
                    }

                    service.setAuthCookie($rootScope.user)
                })
                .catch(function(err) {
                    console.warn("[auth] permissions refresh failed; will retry on next signal", err)
                })
                .finally(function() {
                    refreshInFlight = false
                })
        }

        service.refreshUser = function(success, failure) {

            if ($rootScope.is_authenticated) {

                usersService.getUser($rootScope.user.id).then((data) => {

                    if (data === undefined) {

                        service.logout()

                        if (failure !== undefined) {
                            failure()
                        }

                    } else {

                        data.authentication_token       = $rootScope.user.authentication_token
                        data.scoped_permissions         = $rootScope.user.scoped_permissions
                        data.permissions_state_hash     = $rootScope.user.permissions_state_hash

                        service.setUser(data)

                        if (success !== undefined) {
                            success()
                        }
                    }
                })

            } else if (failure !== undefined) {

                failure()

            }
        }

        $rootScope.$watch("user.preferences", function() {
            service.setAuthCookie($rootScope.user)
        })

        /**
            @param username
         **/
        service.setRememberCookie = function(username) {
            $cookies.putObject("remember_user", username)
            $rootScope.remember_user = $cookies.getObject("remember_user") || {}
        }

        /**
         *
         **/
        service.removeRememberCookie = function() {
            $cookies.remove("remember_user")
            $rootScope.remember_user = {}
        }

        const _logout = () => {

            gtag("set", { user: null })
            gtag("event", "logout")

            authorizationService.clear()

            const options = {
                path: "/",
                domain: $rootScope.config.cookieDomain
            }

            $cookies.remove("user", options)

            if ($rootScope.config.cookieDomain !== "localhost") {
                options.domain = "localhost"
                $cookies.remove("user", options)
            }

            if ($rootScope.config.cookieDomain !== $rootScope.config.realIP) {
                options.domain = $rootScope.config.realIP
                $cookies.remove("user", options)
            }

            $rootScope.is_authenticated = false
        }

        /**
         *
         **/
        service.logout = function(finish) {
            _logout()
            $state.go("login", null, { reload: true }).then(finish)
        }

        service.logoutSoft = function() {
            _logout()
        }

        return service
    }
})()
